"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackSearchResultPage = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackSearchResultPage(search_term, search_result_count) {
    const eventData = {
        eventName: enums_1.GA4EventName.ShowSearchResult,
        feature_category: enums_1.GA4FeatureCategory.Search,
        search_term,
        search_result_count,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData,
    });
}
exports.trackSearchResultPage = trackSearchResultPage;
//# sourceMappingURL=trackSearchResultPage.js.map